import React from 'react'

const V2PoweredBy = ({ className = "" }) => (
    <a
        className={`v2-powered ${className}`.trim()}
        href="https://split50-50.com.au"
        target="_blank"
        rel="noopener noreferrer"
    >
        <img className="v2-powered-mark" src="/resources/s50.png" alt="" />
        Powered by Split 50-50
    </a>
)

export default V2PoweredBy
